<script>
import {generateDonutChart} from "@/shared/charts/donut-chart/donut-chart";
import {debounce} from "lodash";

export default {
  name: "DonutChart",
  props: {
    chartData: {
      type: Array,
      required: true,
    },
    colors: {
      type: Array,
      required: true,
    },
    onSelect: {
      type: Function,
      required: true,
    },
    colorMap: {
      type: Object,
      required: true,
    },
    size: {
      type: Number,
      default: 223,
    },
    parentSize: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    drawChart: function () {

      this.$refs.container.firstChild?.remove();

      var width = this.$refs.container.getBoundingClientRect().width ?? 0;
      var height =
        this.$refs.container.parentElement?.getBoundingClientRect().height ?? 0;

      var size = this.parentSize ? Math.min(width, height) : this.size;

      if (this.parentSize && this.$refs.container) {
        this.$refs.container.style.width = size + "px";
        this.$refs.container.style.height = size + "px";
        this.$refs.container.style.flexGrow = "0";
      }

      var node = generateDonutChart(
        this.chartData,
        this.colors,
        this.colorMap,
        this.onSelect,
        size
      );

      if (node !== null) {
        this.$refs.container.append(node);
      }
    },
  },
  mounted: function () {
    this.drawChart();
  },
  watch: {
    chartData: function () {
      this.drawChart();
    },
  },

};
</script>

<template>
  <div ref="container" class="donut-chart-svg"/>
</template>

<style>
.donut-chart-svg {
  flex-grow: 1;
  padding-top: 8px;
}

.donut-chart-tooltip {
  background-color: #ffffff;
  box-shadow: 0 3px 6px #00000029;
  padding: 6px 3px;
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  z-index: 9999;
  color: #322c2e;
}
</style>
